class ChatError extends Error implements Error {
    name = 'ChatError'
}

export {
    ChatError
}
